import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=3ace3018&scoped=true"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"
import style0 from "./pc.vue?vue&type=style&index=0&id=3ace3018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ace3018",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/examsence/pc.vue
// module id = null
// module chunks = 